module.exports = __webpack_public_path__ + "static/media/logo-onme-color.98b17322.png";